var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container manage"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[(_vm.loadedStatus)?_c('create'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"column is-6"},[(_vm.loadedNewestEvent)?_c('newest'):_vm._e()],1)]),_vm._v(" "),_c('button',{staticClass:"button is-danger",on:{"click":function($event){_vm.logout()}}},[_vm._v("Logout")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63512221","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/Manage.vue
// module id = null
// module chunks = 